/**
 * A container with any pallet on hold is on hold as a whole (Mark, 2026-10-22: "If one is on hold
 * then the whole container is on hold"). The words a screen shows beside it, the same as the
 * API's `ContainerHold.Label` and BOB's utils/containerHold.ts (dock-automation-web).
 */

/** "1 of 20 on hold", or null when none of its pallets is held. */
export function containerHoldLabel(heldPallets: number | null | undefined, pallets: number | null | undefined): string | null {
  const held = Number(heldPallets ?? 0)
  if (!(held > 0)) return null
  return `${held} of ${Math.max(held, Number(pallets ?? 0))} on hold`
}
